<template>
  <base-dialog v-model="dialog" :title="title" :close="false" color="yellow darken-3" width="480px">
    <template v-slot:body>
      <v-sheet class="pa-4 text--primary" style="white-space: pre-wrap">
        {{ message }}
      </v-sheet>
    </template>
    <template v-slot:footer>
      <base-btn label="OK" color="primary" width="96px" @click="onClickOK()" />
    </template>
  </base-dialog>
</template>

<script>
import BaseBtn from "../bases/BaseBtn.vue";
import BaseDialog from "../bases/BaseDialog.vue";

export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: "警告",
  }),
  components: {
    BaseBtn,
    BaseDialog,
  },
  methods: {
    openDialog(option) {
      this.title = option.title != null ? option.title : "警告";
      this.message = option.message != null ? option.message : "警告メッセージ";
      this.btnOK = option.btnOK != null ? option.btnOK : "はい";
      this.dialog = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    onClickOK() {
      this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>
